var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.08,
    height: 16.08,
    viewBox: "0 0 16.08 16.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "approval",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M10.29,2.25l1.8,1.378,2.221-.306.842,2.106,2.106.842L16.951,8.49l1.378,1.8-1.378,1.8.306,2.221-2.106.842-.842,2.106-2.221-.306-1.8,1.378-1.8-1.378-2.221.306-.842-2.106L3.322,14.31l.306-2.221L2.25,10.29l1.378-1.8L3.322,6.27l2.106-.842L6.27,3.322l2.221.306Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M17.873,10.95l-5.207,5.207-2.144-2.144L9.45,15.085,12.666,18.3l6.279-6.279Z",
    transform: "translate(-3.525 -4.259)",
    fill: "#00811d"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.d57c11c405da359ed44f73fa37a6ef96.svg";
export { ForwardRef as ReactComponent };